import { Component, Input } from '@angular/core';
import { TableComponent } from '../../core/table/table.component';
import { ColumnComponent } from '../../core/table/column.component';

@Component({
  selector: 'app-policy-contacts',
  imports: [TableComponent, ColumnComponent],
  template: ` <div class="tw-flex tw-gap-8 tw-pb-8">
    <div class="tw-basis-full">
      <app-table
        [dataSource]="dataSource.contacts"
        [pageSize]="5"
        [scrollable]="false"
        recordLabel="Contact"
      >
        <app-column name="firstName" label="First Name" width="15%" />
        <app-column name="lastName" label="Last Name" width="15%" />
        <app-column name="value" label="Address" width="20%">
          <ng-template let-data #value>
            {{ data.street1 + ' ' + data.street2 + ' ' + data.street3 }}
          </ng-template>
        </app-column>
        <app-column name="city" label="City" width="15%" />
        <app-column name="state" label="State" width="15%" />
        <app-column name="postalCode" label="ZIP" width="15%" />
        <app-column name="country" label="Country" width="15%" />
      </app-table>
    </div>
  </div>`,
})
export class PolicyContactsComponent {
  @Input() dataSource: any;
}
